import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  multipleStatuses: {
    description: 'Text displayed when multiple statuses are picked in the new Refund Status filter',
    defaultMessage: '(Multiple Statuses)',
    id: 'SbUw6T',
  },
  defaultFilterText: {
    defaultMessage: 'Refund Status',
    description: 'default label for refund status filter',
    id: 'MRXNTq',
  },
  multipleVoidTypes: {
    description: 'Text displayed when multiple void types are picked in the Void Type filter',
    defaultMessage: '(Multiple Types)',
    id: 'fxYIIW',
  },
  defaultVoidTypeFilterText: {
    defaultMessage: 'Void Type',
    description: 'default label for void type filter',
    id: 'cE1YSK',
  },
});
